export const SEARCH_DEV_API_URL = 'https://api-dev.search.zoovu.com';
export const SEARCH_API_URL = 'https://api.search.zoovu.com';